import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getMultiDrawingItems = createAsyncThunk(
    "/user/getMultiDrawingItems",
    async (drawingIds) => {
        try {
            const myurl = `${V_URL}/user/get-multi-grid-items`;
            const bodyFormData = new URLSearchParams();
            bodyFormData.append("drawingIds", JSON.stringify(drawingIds));
            const response = await axios({
                method: "POST",
                url: myurl,
                data: bodyFormData,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const getMultiDrawingItemsSlice = createSlice({
    name: "getMultiDrawingItems",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMultiDrawingItems.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMultiDrawingItems.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getMultiDrawingItems.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default getMultiDrawingItemsSlice.reducer;